module.exports = __webpack_public_path__ + "img/img (14).791cb491.jpg";